import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppLocale } from '../../../i18n/localeUtils'
import { IssueEntity } from 'types/IssueEntity'
import { formatDateYYYYMMDD } from '../../../packages/utils/numberFormatters'
import { FactsTableRow } from '../../components/FactsTable'

export function OutcomeDateRow({ issue }: { issue: IssueEntity }) {
    const { t } = useTranslation()
    const { language } = useAppLocale()
    const outcomeDate = issue.sources?.find((s) => s.sourceType === 'Outcome')?.publishedDate
    return (
        <FactsTableRow label={t('pages.issues.terms.outcomeDate')}>
            {formatDateYYYYMMDD(outcomeDate, { locale: language })}
        </FactsTableRow>
    )
}
